/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

export class Constants {
  // AG preferred language list
  public static languages: Language[] = [
    {
      languageName: 'Catalan',
      ISOCode: 'ca',
      regionCode: 'ca-ES',
      SDE_KEY: 'SDE_CATALAN',
      nativeName: 'CatalÃ ',
      order: 1,
      key: '',
      value: '',
    },
    {
      languageName: 'Czech',
      ISOCode: 'cs',
      regionCode: 'cs-CZ',
      SDE_KEY: 'SDE_CZEK',
      nativeName: 'ÄŒeÅ¡tina',
      order: 2,
      key: '',
      value: '',
    },
    {
      languageName: 'Danish',
      ISOCode: 'da',
      regionCode: 'da-DK',
      SDE_KEY: 'SDE_DANISH',
      nativeName: 'Dansk',
      order: 3,
      key: '',
      value: '',
    },
    {
      languageName: 'German',
      ISOCode: 'de',
      regionCode: 'de-DE',
      SDE_KEY: 'SDE_GERMAN',
      nativeName: 'Deutsch',
      order: 4,
      key: '',
      value: '',
    },
    {
      languageName: 'English',
      ISOCode: 'en-us',
      regionCode: 'en-US',
      SDE_KEY: 'SDE_ENGLISH',
      nativeName: 'English',
      order: 5,
      key: '',
      value: '',
    },
    {
      languageName: 'Spanish',
      ISOCode: 'es',
      regionCode: 'es-ES',
      SDE_KEY: 'SDE_SPANISH',
      nativeName: 'EspaÃ±ol',
      order: 6,
      key: '',
      value: '',
    },
    {
      languageName: 'French',
      ISOCode: 'fr',
      regionCode: 'fr-FR',
      SDE_KEY: 'SDE_FRENCH',
      nativeName: 'FranÃ§ais',
      order: 7,
      key: '',
      value: '',
    },
    {
      languageName: 'Italian',
      ISOCode: 'it',
      regionCode: 'it-IT',
      SDE_KEY: 'SDE_ITALIAN',
      nativeName: 'Italiano',
      order: 8,
      key: '',
      value: '',
    },
    {
      languageName: 'Hungarian',
      ISOCode: 'hu',
      regionCode: 'hu-HU',
      SDE_KEY: 'SDE_HUNGARIAN',
      nativeName: 'Magyar',
      order: 9,
      key: '',
      value: '',
    },
    {
      languageName: 'Dutch',
      ISOCode: 'nl',
      regionCode: 'nl-NL',
      SDE_KEY: 'SDE_DUTCH',
      nativeName: 'Nederlands',
      order: 10,
      key: '',
      value: '',
    },
    {
      languageName: 'Norwegian',
      ISOCode: 'no',
      regionCode: 'nb-NO',
      SDE_KEY: 'SDE_NORWEGIAN',
      nativeName: 'Norsk',
      order: 11,
      key: '',
      value: '',
    },
    {
      languageName: 'Polish',
      ISOCode: 'pl',
      regionCode: 'pl-PL',
      SDE_KEY: 'SDE_POLISH',
      nativeName: 'Polski',
      order: 12,
      key: '',
      value: '',
    },
    {
      languageName: 'Portuguese (Brazil)',
      ISOCode: 'pt-br',
      regionCode: 'pt-BR',
      SDE_KEY: 'SDE_PORTUGUESE',
      nativeName: 'PortuguÃªs (Brasil)',
      order: 13,
      key: '',
      value: '',
    },
    {
      languageName: 'Romanian',
      ISOCode: 'ro',
      regionCode: 'ro-RO',
      SDE_KEY: 'SDE_ROMANIAN',
      nativeName: 'RomÃ¢nÄƒ',
      order: 14,
      key: '',
      value: '',
    },
    {
      languageName: 'Finnish',
      ISOCode: 'fi',
      regionCode: 'fi-FI',
      SDE_KEY: 'SDE_FINNISH2',
      nativeName: 'Suomi',
      order: 15,
      key: '',
      value: '',
    },
    {
      languageName: 'Swedish',
      ISOCode: 'sv',
      regionCode: 'sv-SE',
      SDE_KEY: 'SDE_SWEDISH',
      nativeName: 'Svenska',
      order: 16,
      key: '',
      value: '',
    },
    {
      languageName: 'Turkish',
      ISOCode: 'tr',
      regionCode: 'tr-TR',
      SDE_KEY: 'SDE_TURKISH',
      nativeName: 'TÃ¼rkÃ§e',
      order: 17,
      key: '',
      value: '',
    },
    {
      languageName: 'Greek',
      ISOCode: 'el',
      regionCode: 'el-GR',
      SDE_KEY: 'SDE_GREEK',
      nativeName: 'Î•Î»Î»Î·Î½Î¹ÎºÎ¬',
      order: 18,
      key: '',
      value: '',
    },
    {
      languageName: 'Russian',
      ISOCode: 'ru',
      regionCode: 'ru-RU',
      SDE_KEY: 'SDE_RUSSIAN',
      nativeName: 'Ð ÑƒÑÑÐºÐ¸Ð¹',
      order: 19,
      key: '',
      value: '',
    },
  ];

  public static middlewareDestinations: CloudDestination[] = [
    {
      key: 'DocuShare<sup>&reg;</sup> Go United States',
      value: 'DocuShare',
      region: 'US',
    },
    {
      key: 'DocuShare<sup>&reg;</sup> Go Europe',
      value: 'DocuShare',
      region: 'EU',
    },
    {
      key: 'Microsoft<sup>&reg;</sup> 365 SharePoint',
      value: 'GraphSharePoint',
      region: '',
    },
    {
      key: 'Microsoft<sup>&reg;</sup> OneDrive',
      value: 'GraphOneDrive',
      region: '',
    },
    {
      key: 'Google Drive&trade;',
      value: 'GoogleDrive',
      region: '',
    },
    {
      key: 'Dropbox<sup>&reg;</sup>',
      value: 'Dropbox',
      region: '',
    },
    {
      key: 'Box&trade;',
      value: 'Box',
      region: '',
    },
  ];
}

export interface Language {
  languageName: string;
  ISOCode: string;
  regionCode: string;
  SDE_KEY: string;
  nativeName: string;
  order: number;
  key: string;
  value: string;
}

export interface CloudDestination {
  key: string;
  value: string;
  region: string;
}
